import React from 'react';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://www.linkedin.com/in/nitin-kumar-7a747926b?trk=contact-info" target="_blank" rel="noopener noreferrer">
        <AiFillLinkedin />
      </a>
    </div>
    <div>
      <a href="https://github.com/nitin17112001kumar" target="_blank" rel="noopener noreferrer">
        <AiFillGithub />
      </a>
    </div>
  </div>
);

export default SocialMedia;
